/* eslint-disable */
import { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL     = "https://wvpwmxfnfoetoqokdahh.supabase.co";
const SUPABASE_ANON    = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind2cHdteGZuZm9ldG9xb2tkYWhoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc2OTk1MTgsImV4cCI6MjA5MzI3NTUxOH0.8HnlOOzGBu_JOpwYmgHdKz7DAzhs7s9BBrY8jDtQXMk";
const SUPABASE_SERVICE = "sb_secret_Dbtw8v_v6x-3RejHg2ocxg_L4FSTRi-";
const supabase         = createClient(SUPABASE_URL, SUPABASE_ANON);
const supabaseAdmin    = createClient(SUPABASE_URL, SUPABASE_SERVICE, { auth: { storageKey: "sb-admin-key" } });

// Email admin — seul cet email a accès à l'espace Admin complet
const ADMIN_EMAIL = "arnaudlamothe@oreka-immobilier.fr";

// ─────────────────────────────────────────────
// CSS
// ─────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&family=Lora:ital,wght@0,400;0,500;1,400&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  :root{
    --green:#2D6A2D;--green-mid:#3D8B3D;--green-pale:#E8F4E8;--green-bg:#F2FAF2;
    --white:#FFFFFF;--gray-bg:#F7F7F7;--gray-line:#E0E0E0;--gray-text:#666;--black:#1A1A1A;
    --red:#C0392B;--orange:#D97706;--blue:#2980B9;
    --shadow:0 2px 10px rgba(0,0,0,0.07);--shadow-md:0 4px 20px rgba(0,0,0,0.11);--radius:8px;
  }
  body{font-family:'Raleway',sans-serif;background:var(--gray-bg);color:var(--black);min-height:100vh}

  /* AUTH */
  .auth-page{min-height:100vh;display:flex;align-items:center;justify-content:center;background:var(--white);position:relative}
  .auth-page::before{content:'';position:absolute;bottom:0;left:0;right:0;height:5px;background:var(--green)}
  .auth-page::after{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:var(--green)}
  .auth-card{background:var(--white);border:1px solid var(--gray-line);border-radius:12px;padding:48px;width:440px;box-shadow:var(--shadow-md)}
  .oi-logo{display:flex;align-items:center;gap:14px;margin-bottom:28px}
  .oi-circle{width:54px;height:54px;border:3px solid var(--green);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0}
  .oi-initials{font-size:17px;font-weight:700;color:var(--green)}
  .oi-name{font-size:14px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:var(--black)}
  .oi-tagline{font-size:11px;color:var(--gray-text);margin-top:3px}
  .auth-divider{height:1px;background:var(--gray-line);margin-bottom:24px}
  .auth-title{font-family:'Lora',serif;font-size:22px;font-weight:400;color:var(--black);margin-bottom:5px}
  .auth-subtitle{font-size:12px;color:var(--gray-text);margin-bottom:26px}
  .form-group{margin-bottom:14px}
  .form-label{font-size:10px;font-weight:700;color:var(--gray-text);text-transform:uppercase;letter-spacing:.1em;margin-bottom:5px;display:block}
  .form-input{width:100%;background:var(--gray-bg);border:1px solid var(--gray-line);border-radius:5px;padding:10px 12px;color:var(--black);font-family:'Raleway',sans-serif;font-size:13px;outline:none;transition:border-color .15s}
  .form-input:focus{border-color:var(--green);background:var(--white)}
  select.form-input{appearance:auto}
  .auth-btn{width:100%;padding:12px;background:var(--green);color:white;border:none;border-radius:6px;font-family:'Raleway',sans-serif;font-size:13px;font-weight:700;cursor:pointer;transition:background .15s;margin-top:6px;letter-spacing:.04em}
  .auth-btn:hover{background:var(--green-mid)}
  .auth-btn:disabled{background:var(--gray-text);cursor:not-allowed}
  .auth-error{background:#FDEDEC;border:1px solid #F5C6C6;border-radius:6px;padding:10px 14px;font-size:12px;color:var(--red);margin-bottom:14px}
  .auth-success{background:var(--green-pale);border:1px solid #B8DEB8;border-radius:6px;padding:10px 14px;font-size:12px;color:var(--green);margin-bottom:14px}
  .auth-footer{margin-top:24px;padding-top:18px;border-top:1px solid var(--gray-line);font-size:11px;color:var(--gray-text);display:flex;flex-direction:column;gap:3px}
  .auth-footer a{color:var(--green);text-decoration:none}
  .loading{display:flex;align-items:center;justify-content:center;min-height:100vh;font-size:14px;color:var(--gray-text)}

  /* ROLE BADGE */
  .role-badge{display:inline-flex;align-items:center;gap:6px;padding:4px 12px;border-radius:20px;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase}
  .role-admin{background:var(--black);color:white}
  .role-prop{background:var(--green-pale);color:var(--green)}
  .role-loc{background:#EAF2FB;color:var(--blue)}

  /* APP */
  .app{display:flex;min-height:100vh}
  .sidebar{width:252px;flex-shrink:0;background:var(--green);display:flex;flex-direction:column}
  .sidebar-logo{padding:20px 18px 16px;border-bottom:1px solid rgba(255,255,255,.15)}
  .sidebar-logo .oi-circle{border-color:rgba(255,255,255,.65)}
  .sidebar-logo .oi-initials{color:rgba(255,255,255,.9)}
  .sidebar-logo .oi-name{color:#fff}
  .sidebar-logo .oi-tagline{color:rgba(255,255,255,.55)}
  .user-badge{padding:12px 18px;border-bottom:1px solid rgba(255,255,255,.15);display:flex;align-items:center;gap:10px}
  .avatar{width:36px;height:36px;border-radius:50%;background:rgba(255,255,255,.18);border:2px solid rgba(255,255,255,.35);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:white;flex-shrink:0}
  .user-name{font-size:13px;font-weight:600;color:white}
  .user-role-txt{font-size:10px;color:rgba(255,255,255,.6);margin-top:1px;letter-spacing:.08em;text-transform:uppercase}
  .nav{flex:1;padding:8px 0;overflow-y:auto}
  .nav-section{padding:10px 16px 3px;font-size:9px;font-weight:700;letter-spacing:.16em;color:rgba(255,255,255,.4);text-transform:uppercase}
  .nav-item{display:flex;align-items:center;gap:9px;padding:10px 16px;cursor:pointer;transition:all .15s;border-left:3px solid transparent;font-size:13px;color:rgba(255,255,255,.75)}
  .nav-item:hover{background:rgba(255,255,255,.1);color:white}
  .nav-item.active{background:rgba(255,255,255,.18);border-left-color:white;color:white;font-weight:600}
  .nav-item .ni-icon{font-size:14px;width:18px}
  .nav-badge{margin-left:auto;background:#E74C3C;color:white;font-size:9px;font-weight:700;padding:2px 6px;border-radius:10px}
  .sidebar-contact{padding:12px 16px;border-top:1px solid rgba(255,255,255,.15);font-size:10px;color:rgba(255,255,255,.45);line-height:1.8}
  .sidebar-contact a{color:rgba(255,255,255,.6);text-decoration:none}
  .logout-btn{padding:12px 16px;border-top:1px solid rgba(255,255,255,.15);display:flex;align-items:center;gap:8px;cursor:pointer;font-size:12px;color:rgba(255,255,255,.5);transition:color .15s}
  .logout-btn:hover{color:white}
  .main{flex:1;display:flex;flex-direction:column;overflow:hidden}
  .topbar{padding:14px 26px;border-bottom:1px solid var(--gray-line);background:var(--white);display:flex;align-items:center;justify-content:space-between;box-shadow:var(--shadow)}
  .page-title{font-family:'Lora',serif;font-size:21px;font-weight:400;color:var(--black)}
  .page-bar{width:28px;height:3px;background:var(--green);margin-top:5px}
  .page-subtitle{font-size:11px;color:var(--gray-text);margin-top:2px}
  .content{flex:1;overflow-y:auto;padding:22px 26px}
  .btn{padding:8px 18px;border-radius:5px;font-size:12px;font-weight:600;cursor:pointer;border:none;transition:all .15s;font-family:'Raleway',sans-serif;letter-spacing:.04em}
  .btn-primary{background:var(--green);color:white}
  .btn-primary:hover{background:var(--green-mid)}
  .btn-ghost{background:transparent;color:var(--black);border:1.5px solid var(--gray-line)}
  .btn-ghost:hover{border-color:var(--green);color:var(--green)}
  .btn-danger{background:#FDEDEC;color:var(--red);border:1px solid #F5C6C6}
  .card{background:var(--white);border:1px solid var(--gray-line);border-radius:var(--radius);padding:20px;box-shadow:var(--shadow)}
  .stitle{font-family:'Lora',serif;font-size:18px;font-weight:400;color:var(--black);margin-bottom:4px}
  .sbar{width:28px;height:2px;background:var(--green);margin-bottom:14px}
  .grid-2{display:grid;grid-template-columns:1fr 1fr;gap:16px}
  .grid-3{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
  .grid-4{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}
  .g20{margin-bottom:20px}
  .kpi-val{font-family:'Lora',serif;font-size:28px;font-weight:400;color:var(--black);margin-bottom:3px;line-height:1}
  .kpi-val.accent{color:var(--green)}
  .kpi-lbl{font-size:10px;color:var(--gray-text);font-weight:500;text-transform:uppercase;letter-spacing:.08em}
  .kpi-sub{font-size:11px;color:var(--gray-text);margin-top:5px}
  .kpi-ico{font-size:20px;margin-bottom:8px}
  .badge{display:inline-flex;align-items:center;padding:3px 9px;border-radius:4px;font-size:11px;font-weight:600}
  .badge-green{background:var(--green-pale);color:var(--green)}
  .badge-red{background:#FDEDEC;color:var(--red)}
  .badge-orange{background:#FEF3E2;color:var(--orange)}
  .badge-blue{background:#EAF2FB;color:var(--blue)}
  .badge-gray{background:var(--gray-bg);color:var(--gray-text);border:1px solid var(--gray-line)}
  .table-wrap{overflow-x:auto}
  table{width:100%;border-collapse:collapse;font-size:13px}
  th{text-align:left;padding:10px 13px;font-size:10px;font-weight:700;color:white;text-transform:uppercase;letter-spacing:.1em;background:var(--green)}
  th:first-child{border-radius:5px 0 0 0}th:last-child{border-radius:0 5px 0 0}
  td{padding:10px 13px;border-bottom:1px solid var(--gray-line);color:var(--black)}
  tr:last-child td{border-bottom:none}
  tr:nth-child(even) td{background:var(--gray-bg)}
  tr:hover td{background:var(--green-bg)!important}
  .bien-card{background:var(--white);border:1px solid var(--gray-line);border-radius:var(--radius);overflow:hidden;transition:all .2s;box-shadow:var(--shadow)}
  .bien-card:hover{border-color:var(--green);transform:translateY(-2px);box-shadow:var(--shadow-md)}
  .bien-header{padding:14px 16px;border-bottom:3px solid var(--green);background:var(--green-bg);display:flex;align-items:flex-start;gap:11px}
  .bien-icon{font-size:24px}
  .bien-adresse{font-weight:700;font-size:13px;line-height:1.4;color:var(--black)}
  .bien-type{font-size:11px;color:var(--gray-text);margin-top:2px}
  .bien-body{padding:12px 16px}
  .bien-row{display:flex;justify-content:space-between;align-items:center;padding:5px 0;font-size:12px;border-bottom:1px solid var(--gray-line)}
  .bien-row:last-child{border-bottom:none}
  .bien-row-lbl{color:var(--gray-text)}
  .loyer-big{font-family:'Lora',serif;font-size:22px;color:var(--green);font-weight:500}
  .bien-footer{padding:10px 16px;background:var(--gray-bg);border-top:1px solid var(--gray-line);display:flex;justify-content:space-between;align-items:center}
  .msg-item{padding:11px 13px;cursor:pointer;transition:background .15s;display:flex;align-items:flex-start;gap:10px;border-bottom:1px solid var(--gray-line)}
  .msg-item:hover{background:var(--green-bg)}
  .msg-item.unread{background:var(--green-pale);border-left:3px solid var(--green);padding-left:10px}
  .msg-dot{width:7px;height:7px;background:var(--green);border-radius:50%;flex-shrink:0;margin-top:5px}
  .msg-from{font-size:13px;font-weight:700;color:var(--black)}
  .msg-prev{font-size:12px;color:var(--gray-text);margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:280px}
  .msg-date{font-size:11px;color:var(--gray-text);margin-left:auto;flex-shrink:0}
  .compose-box{background:var(--gray-bg);border:1px solid var(--gray-line);border-radius:var(--radius);padding:12px;margin-top:12px}
  .compose-input{width:100%;background:transparent;border:none;outline:none;color:var(--black);font-family:'Raleway',sans-serif;font-size:13px;resize:none;min-height:68px}
  .compose-input::placeholder{color:var(--gray-text)}
  .travail-item{display:flex;align-items:flex-start;gap:12px;padding:13px;background:var(--gray-bg);border:1px solid var(--gray-line);border-radius:6px;margin-bottom:8px;transition:border-color .15s}
  .travail-item:hover{border-color:var(--green)}
  .travail-ico{font-size:18px;flex-shrink:0;margin-top:2px}
  .travail-desc{font-size:13px;font-weight:600;color:var(--black)}
  .travail-meta{font-size:11px;color:var(--gray-text);margin-top:3px}
  .loc-hero{background:var(--green);border-radius:var(--radius);padding:20px 24px;color:white;display:flex;justify-content:space-between;align-items:center;margin-bottom:18px}
  .loc-hero-title{font-family:'Lora',serif;font-size:19px;margin-bottom:3px}
  .loc-hero-sub{font-size:12px;opacity:.75}
  .modal-bg{position:fixed;inset:0;background:rgba(0,0,0,.42);display:flex;align-items:center;justify-content:center;z-index:100}
  .modal{background:var(--white);border:1px solid var(--gray-line);border-radius:12px;padding:28px;width:460px;max-height:85vh;overflow-y:auto;box-shadow:var(--shadow-md)}
  .modal-title{font-family:'Lora',serif;font-size:19px;font-weight:400;color:var(--black);margin-bottom:4px}
  .modal-bar{width:28px;height:2px;background:var(--green);margin-bottom:20px}
  .modal-actions{display:flex;gap:10px;margin-top:18px;justify-content:flex-end}
  .footer-bar{padding:10px 26px;background:var(--white);border-top:3px solid var(--green);display:flex;align-items:center;justify-content:space-between;font-size:11px;color:var(--gray-text)}
  .footer-bar a{color:var(--green);text-decoration:none;font-weight:600}
  .empty{text-align:center;padding:44px;color:var(--gray-text)}
  .empty-icon{font-size:34px;margin-bottom:10px}
  .empty-text{font-size:13px}
  .invite-box{background:var(--green-bg);border:1px solid #B8DEB8;border-radius:var(--radius);padding:16px 20px;margin-bottom:20px;display:flex;align-items:center;justify-content:space-between;gap:16px}
  .invite-box-text{font-size:13px;color:var(--green);font-weight:500}
  .invite-box-sub{font-size:11px;color:var(--gray-text);margin-top:2px}
  ::-webkit-scrollbar{width:5px}
  ::-webkit-scrollbar-track{background:transparent}
  ::-webkit-scrollbar-thumb{background:var(--gray-line);border-radius:3px}
`;

// ─────────────────────────────────────────────
// UTILITAIRES
// ─────────────────────────────────────────────
function initiales(nom) {
  if (!nom) return "?";
  return nom.split(" ").map(p => p[0]).join("").toUpperCase().slice(0, 2);
}

function BadgeStatut({ s }) {
  const map = {
    "Payé":       "badge-green", "En attente": "badge-orange", "Retard":   "badge-red",
    "Occupé":     "badge-blue",  "Vacant":     "badge-gray",   "En cours": "badge-orange",
    "Planifié":   "badge-blue",  "Terminé":    "badge-green",
  };
  const icons = { "Payé":"✓ ","En attente":"⏳ ","Retard":"⚠ ","Occupé":"● ","Vacant":"○ ","En cours":"⚙ ","Planifié":"📅 ","Terminé":"✓ " };
  return <span className={`badge ${map[s] || "badge-gray"}`}>{icons[s] || ""}{s}</span>;
}

function OILogo({ light = false }) {
  return (
    <div className="oi-logo">
      <div className="oi-circle" style={light ? { borderColor: "rgba(255,255,255,0.65)" } : {}}>
        <span className="oi-initials" style={light ? { color: "rgba(255,255,255,0.9)" } : {}}>OI</span>
      </div>
      <div>
        <div className="oi-name" style={light ? { color: "white" } : {}}>{light ? "OREKA IMMOBILIER" : "Oreka Immobilier"}</div>
        <div className="oi-tagline" style={light ? { color: "rgba(255,255,255,0.55)" } : {}}>Agence immobilière — Boucau</div>
      </div>
    </div>
  );
}

function ST({ children }) {
  return <><div className="stitle">{children}</div><div className="sbar" /></>;
}

function Modal({ title, onClose, children }) {
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-title">{title}</div>
        <div className="modal-bar" />
        {children}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE CONNEXION
// ─────────────────────────────────────────────
function AuthPage({ onAuth }) {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  async function handleLogin(e) {
    e.preventDefault(); setLoading(true); setError("");
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { setError("Email ou mot de passe incorrect."); setLoading(false); return; }
    const { data: profile } = await supabase.from("profiles").select("*").eq("id", data.user.id).single();
    if (profile) onAuth(profile);
    else {
      // Créer profil admin si premier login
      if (email === ADMIN_EMAIL) {
        const newProfile = { id: data.user.id, email, nom: "Arnaud Lamothe", role: "admin", avatar: "AL" };
        await supabase.from("profiles").insert(newProfile);
        onAuth(newProfile);
      }
    }
    setLoading(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <OILogo />
        <div className="auth-divider" />
        <div className="auth-title">Connexion</div>
        <div className="auth-subtitle">Accédez à votre espace personnel</div>
        {error && <div className="auth-error">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" placeholder="votre@email.com" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label">Mot de passe</label>
            <input className="form-input" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>
          <button className="auth-btn" type="submit" disabled={loading}>{loading ? "Connexion..." : "Se connecter"}</button>
        </form>
        <div className="auth-footer">
          <span>📞 06 77 03 31 35 · <a href="mailto:arnaudlamothe@oreka-immobilier.fr">arnaudlamothe@oreka-immobilier.fr</a></span>
          <span>3 impasse des Sittelles, 64340 Boucau · <a href="https://www.oreka-immobilier.fr" target="_blank" rel="noreferrer">www.oreka-immobilier.fr</a></span>
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// SIDEBAR
// ─────────────────────────────────────────────
function Sidebar({ profile, activePage, onNav, onLogout, unread }) {
  const isAdmin = profile.role === "admin" || profile.email === ADMIN_EMAIL;
  const isProp  = profile.role === "proprietaire";

  const navAdmin = [
    { section: "Administration" },
    { id: "dashboard",    label: "Tableau de bord",        icon: "📊" },
    { id: "utilisateurs", label: "Utilisateurs",           icon: "👥" },
    { id: "biens",        label: "Tous les biens",         icon: "🏠" },
    { id: "loyers",       label: "Tous les loyers",        icon: "💶" },
    { id: "travaux",      label: "Interventions",          icon: "🔧" },
    { section: "Outils" },
    { id: "documents",    label: "Documents",              icon: "📁" },
    { id: "messages",     label: "Messages",               icon: "💬", badge: unread },
    { id: "versements",   label: "Paiements propriétaires", icon: "💰" },
    { id: "fiscalite",    label: "Revenus fonciers",       icon: "📈" },
  ];

  const navProp = [
    { section: "Mon espace" },
    { id: "dashboard",  label: "Vue d'ensemble",           icon: "📊" },
    { id: "biens",      label: "Mes biens",                icon: "🏠" },
    { id: "locataires", label: "Mes locataires",           icon: "👥" },
    { id: "loyers",     label: "Loyers & quittances",      icon: "💶" },
    { id: "travaux",    label: "Travaux & interventions",  icon: "🔧" },
    { section: "Outils" },
    { id: "documents",  label: "Documents",                icon: "📁" },
    { id: "versements",  label: "Mes versements",           icon: "💰" },
    { id: "messages",   label: "Messages",                 icon: "💬", badge: unread },
  ];

  const navLoc = [
    { section: "Mon espace" },
    { id: "dashboard",     label: "Tableau de bord",       icon: "📊" },
    { id: "mon-bail",      label: "Mon bail",              icon: "📄" },
    { id: "mes-paiements", label: "Mes paiements",         icon: "💶" },
    { section: "Outils" },
    { id: "documents",     label: "Mes documents",         icon: "📁" },
    { id: "messages",      label: "Messages",              icon: "💬", badge: unread },
    { id: "travaux",       label: "Signaler un problème",  icon: "🔧" },
  ];

  const nav = isAdmin ? navAdmin : isProp ? navProp : navLoc;
  const roleLabel = isAdmin ? "Administrateur" : isProp ? "Propriétaire" : "Locataire";

  return (
    <div className="sidebar">
      <div className="sidebar-logo"><OILogo light /></div>
      <div className="user-badge">
        <div className="avatar">{profile.avatar || initiales(profile.nom)}</div>
        <div>
          <div className="user-name">{profile.nom}</div>
          <div className="user-role-txt">{roleLabel}</div>
        </div>
      </div>
      <nav className="nav">
        {nav.map((item, i) => {
          if (item.section) return <div key={i} className="nav-section">{item.section}</div>;
          return (
            <div key={item.id} className={`nav-item${activePage === item.id ? " active" : ""}`} onClick={() => onNav(item.id)}>
              <span className="ni-icon">{item.icon}</span>
              {item.label}
              {item.badge > 0 && <span className="nav-badge">{item.badge}</span>}
            </div>
          );
        })}
      </nav>
      <div className="sidebar-contact">
        <div>📞 06 77 03 31 35</div>
        <div><a href="mailto:arnaudlamothe@oreka-immobilier.fr">arnaudlamothe@oreka-immobilier.fr</a></div>
        <div>3 impasse des Sittelles · 64340 Boucau</div>
      </div>
      <div className="logout-btn" onClick={onLogout}>↩ Se déconnecter</div>
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE UTILISATEURS (Admin)
// ─────────────────────────────────────────────
// ─────────────────────────────────────────────
// COMPOSANT UPLOAD DOCUMENTS
// ─────────────────────────────────────────────
function UploadDocuments({ associe_nom, associe_type, documents, onRefresh }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress]  = useState(0);
  const [drag, setDrag]          = useState(false);
  const [showAdd, setShowAdd]    = useState(false);
  const [typeDoc, setTypeDoc]    = useState("Bail");
  const mesDocs = documents.filter(d => d.associe_nom === associe_nom);

  async function handleFile(file) {
    if (!file) return;
    setUploading(true); setProgress(10);
    const ext      = file.name.split(".").pop();
    // Nettoyer le nom : supprimer accents, espaces et caractères spéciaux
    const cleanNom = associe_nom.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, "_");
    const cleanFile = file.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9._-]/g, "_");
    const path     = `${associe_type}/${cleanNom}/${Date.now()}_${cleanFile}`;
    const { data, error } = await supabase.storage.from("documents").upload(path, file, { upsert: true });
    setProgress(70);
    if (!error) {
      const { data: urlData } = supabase.storage.from("documents").getPublicUrl(path);
      const icon = ext === "pdf" ? "📄" : ["jpg","jpeg","png","gif","webp"].includes(ext) ? "🖼️" : ["doc","docx"].includes(ext) ? "📝" : "📎";
      await supabase.from("documents").insert({
        nom: file.name, type: typeDoc, associe_nom, associe_type,
        bien_adresse: associe_nom, url: urlData.publicUrl, icon,
      });
      setProgress(100);
      setTimeout(() => { setUploading(false); setProgress(0); setShowAdd(false); onRefresh(); }, 500);
    } else {
      setUploading(false); setProgress(0);
      alert("Erreur upload : " + error.message);
    }
  }

  async function handleDelete(doc) {
    if (!window.confirm("Supprimer ce document ?")) return;
    const path = doc.url.split("/documents/")[1];
    await supabase.storage.from("documents").remove([path]);
    await supabase.from("documents").delete().eq("id", doc.id);
    onRefresh();
  }

  function getFileIcon(nom) {
    const ext = (nom || "").split(".").pop().toLowerCase();
    if (ext === "pdf") return "📄";
    if (["jpg","jpeg","png","gif","webp"].includes(ext)) return "🖼️";
    if (["doc","docx"].includes(ext)) return "📝";
    if (["xls","xlsx"].includes(ext)) return "📊";
    return "📎";
  }

  return (
    <div>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
        <div style={{ fontSize:12, color:"var(--gray-text)", fontWeight:600, textTransform:"uppercase", letterSpacing:".08em" }}>
          Documents ({mesDocs.length})
        </div>
        <button className="btn btn-primary" style={{ padding:"5px 12px", fontSize:11 }} onClick={e => { e.stopPropagation(); setShowAdd(true); }}>
          + Ajouter
        </button>
      </div>

      {showAdd && (
        <div className="modal-bg" onClick={e => { e.stopPropagation(); setShowAdd(false); }}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-title">Ajouter un document</div>
            <div className="modal-bar" />
            <div className="form-group">
              <label className="form-label">Catégorie</label>
              <select className="form-input" value={typeDoc} onChange={e => setTypeDoc(e.target.value)}>
                <option>Bail</option><option>État des lieux</option><option>Quittance</option>
                <option>Assurance</option><option>Diagnostic</option><option>Mandat</option>
                <option>Identité</option><option>Justificatif</option><option>Autre</option>
              </select>
            </div>
            <div
              className={`upload-zone${drag ? " drag" : ""}`}
              onDragOver={e => { e.preventDefault(); setDrag(true); }}
              onDragLeave={() => setDrag(false)}
              onDrop={e => { e.preventDefault(); setDrag(false); handleFile(e.dataTransfer.files[0]); }}
              onClick={() => document.getElementById("file-input-" + associe_nom.replace(/\s/g,"_")).click()}
            >
              <div className="upload-zone-icon">📁</div>
              <div className="upload-zone-text">Cliquez ou glissez un fichier ici</div>
              <div className="upload-zone-sub">PDF, Word, Excel, images — tous formats acceptés</div>
              <input
                id={"file-input-" + associe_nom.replace(/\s/g,"_")}
                type="file" style={{ display:"none" }}
                onChange={e => handleFile(e.target.files[0])}
              />
            </div>
            {uploading && (
              <div style={{ marginTop:12 }}>
                <div style={{ fontSize:11, color:"var(--gray-text)", marginBottom:4 }}>Upload en cours...</div>
                <div className="progress-bar"><div className="progress-fill" style={{ width: progress + "%" }} /></div>
              </div>
            )}
            <div className="modal-actions">
              <button className="btn btn-ghost" onClick={e => { e.stopPropagation(); setShowAdd(false); }}>Fermer</button>
            </div>
          </div>
        </div>
      )}

      {mesDocs.map(d => (
        <div key={d.id} className="doc-item">
          <div className="doc-icon">{getFileIcon(d.nom)}</div>
          <div style={{ flex:1, minWidth:0 }}>
            <div className="doc-name" style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{d.nom}</div>
            <div className="doc-meta">{d.type} · {new Date(d.created_at).toLocaleDateString("fr-FR")}</div>
          </div>
          <div className="doc-actions">
            <a href={d.url} target="_blank" rel="noreferrer" className="btn btn-ghost" style={{ padding:"4px 10px", fontSize:11, textDecoration:"none" }}>⬇ Ouvrir</a>
            <button className="btn btn-danger" style={{ padding:"4px 10px", fontSize:11 }} onClick={() => handleDelete(d)}>✕</button>
          </div>
        </div>
      ))}
      {mesDocs.length === 0 && !showAdd && (
        <div style={{ fontSize:12, color:"var(--gray-text)", fontStyle:"italic", padding:"8px 0" }}>Aucun document</div>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE UTILISATEURS (Admin) — création autonome
// ─────────────────────────────────────────────
function PageUtilisateurs({ profiles, biens, documents, onRefresh }) {
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm]   = useState({ nom: "", email: "", role: "locataire", telephone: "" });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]     = useState("");
  const [selected, setSelected] = useState(null);

  const proprietaires = profiles.filter(p => p.role === "proprietaire");
  const locataires    = profiles.filter(p => p.role === "locataire");

  async function handleCreate(e) {
    e.preventDefault(); setSaving(true); setMsg("");
    // Créer le profil directement sans authentification (l'admin gère tout)
    const fakeId = crypto.randomUUID();
    const { error } = await supabase.from("profiles").insert({
      id: fakeId, email: form.email, nom: form.nom,
      role: form.role, avatar: initiales(form.nom),
      statut: "actif"
    });
    if (!error) {
      setMsg("✓ " + form.nom + " créé avec succès.");
      setForm({ nom: "", email: "", role: "locataire", telephone: "" });
      setShowCreate(false);
      onRefresh();
    } else {
      setMsg("Erreur : " + error.message);
    }
    setSaving(false);
  }

  const selectedProfile = profiles.find(p => p.id === selected);
  const selectedBien    = selectedProfile ? biens.find(b =>
    selectedProfile.role === "locataire"
      ? b.locataire_nom === selectedProfile.nom
      : b.proprietaire_nom === selectedProfile.nom
  ) : null;

  return (
    <div>
      {msg && <div className="auth-success" style={{ marginBottom:16 }}>{msg}</div>}

      <div style={{ display:"flex", gap:12, marginBottom:20 }}>
        <button className="btn btn-primary" onClick={() => { setShowCreate(true); setForm({...form, role:"proprietaire"}); }}>+ Nouveau propriétaire</button>
        <button className="btn btn-primary" onClick={() => { setShowCreate(true); setForm({...form, role:"locataire"}); }}>+ Nouveau locataire</button>
      </div>

      {showCreate && (
        <div className="create-form">
          <div className="create-form-title">Créer un {form.role === "proprietaire" ? "propriétaire" : "locataire"}</div>
          <form onSubmit={handleCreate}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:11, marginBottom:13 }}>
              <div className="form-group">
                <label className="form-label">Nom complet</label>
                <input className="form-input" placeholder="Prénom Nom" value={form.nom} onChange={e => setForm({...form, nom:e.target.value})} required />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-input" type="email" placeholder="email@exemple.com" value={form.email} onChange={e => setForm({...form, email:e.target.value})} />
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:11, marginBottom:13 }}>
              <div className="form-group">
                <label className="form-label">Rôle</label>
                <select className="form-input" value={form.role} onChange={e => setForm({...form, role:e.target.value})}>
                  <option value="locataire">Locataire</option>
                  <option value="proprietaire">Propriétaire</option>
                </select>
              </div>
            </div>
            <div style={{ display:"flex", gap:10 }}>
              <button className="btn btn-ghost" type="button" onClick={() => setShowCreate(false)}>Annuler</button>
              <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? "Création..." : "Créer"}</button>
            </div>
          </form>
        </div>
      )}

      <div className="grid-2">
        <div>
          <ST>Propriétaires ({proprietaires.length})</ST>
          {proprietaires.map(p => (
            <div
              key={p.id}
              className="profile-card"
              style={{ cursor:"pointer", borderColor: selected===p.id ? "var(--green)" : "var(--gray-line)" }}
              onClick={() => setSelected(selected===p.id ? null : p.id)}
            >
              <div className="profile-header">
                <div className="profile-avatar">{initiales(p.nom)}</div>
                <div style={{ flex:1 }}>
                  <div className="profile-nom">{p.nom}</div>
                  <div className="profile-email">{p.email || "—"}</div>
                  <div style={{ marginTop:4 }}>
                    <span className="badge badge-green" style={{ fontSize:10 }}>
                      {biens.filter(b => b.proprietaire_nom === p.nom).length} bien(s)
                    </span>
                  </div>
                </div>
              </div>
              {selected === p.id && (
                <UploadDocuments
                  associe_nom={p.nom}
                  associe_type="proprietaire"
                  documents={documents}
                  onRefresh={onRefresh}
                />
              )}
            </div>
          ))}
          {proprietaires.length === 0 && <div className="empty" style={{padding:24}}><div className="empty-text">Aucun propriétaire créé</div></div>}
        </div>

        <div>
          <ST>Locataires ({locataires.length})</ST>
          {locataires.map(p => {
            const bien = biens.find(b => b.locataire_nom === p.nom);
            return (
              <div
                key={p.id}
                className="profile-card"
                style={{ cursor:"pointer", borderColor: selected===p.id ? "var(--green)" : "var(--gray-line)" }}
                onClick={() => setSelected(selected===p.id ? null : p.id)}
              >
                <div className="profile-header">
                  <div className="profile-avatar" style={{ background:"var(--blue)" }}>{initiales(p.nom)}</div>
                  <div style={{ flex:1 }}>
                    <div className="profile-nom">{p.nom}</div>
                    <div className="profile-email">{p.email || "—"}</div>
                    {bien && <div style={{ marginTop:4 }}><span className="badge badge-blue" style={{ fontSize:10 }}>{bien.adresse.split(",")[0]}</span></div>}
                  </div>
                </div>
                {selected === p.id && (
                  <UploadDocuments
                    associe_nom={p.nom}
                    associe_type="locataire"
                    documents={documents}
                    onRefresh={onRefresh}
                  />
                )}
              </div>
            );
          })}
          {locataires.length === 0 && <div className="empty" style={{padding:24}}><div className="empty-text">Aucun locataire créé</div></div>}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE BIENS
// ─────────────────────────────────────────────
function PageBiens({ biens, profiles, isAdmin, currentProfile, onRefresh }) {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ adresse: "", type: "Appartement", surface: "", loyer: "", charges: "", photo: "🏠", proprietaire_nom: "", locataire_nom: "", bail_debut: "", bail_fin: "" });
  const [saving, setSaving] = useState(false);

  const proprietaires = profiles.filter(p => p.role === "proprietaire");
  const locataires    = profiles.filter(p => p.role === "locataire");
  const biensFiltres  = isAdmin ? biens : biens.filter(b => b.proprietaire_nom === currentProfile.nom);

  async function handleAdd(e) {
    e.preventDefault(); setSaving(true);
    const statut = form.locataire_nom ? "Occupé" : "Vacant";
    await supabase.from("biens").insert({ ...form, surface: parseInt(form.surface) || null, loyer: parseInt(form.loyer), charges: parseInt(form.charges) || 0, statut });
    setSaving(false); setShowModal(false);
    setForm({ adresse: "", type: "Appartement", surface: "", loyer: "", charges: "", photo: "🏠", proprietaire_nom: "", locataire_nom: "", bail_debut: "", bail_fin: "" });
    onRefresh();
  }

  async function handleDelete(id) {
    if (!window.confirm("Supprimer ce bien définitivement ?")) return;
    await supabase.from("biens").delete().eq("id", id);
    onRefresh();
  }

  return (
    <div>
      {isAdmin && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Ajouter un bien</button>
        </div>
      )}
      {biensFiltres.length === 0 ? (
        <div className="card empty"><div className="empty-icon">🏠</div><div className="empty-text">Aucun bien enregistré</div></div>
      ) : (
        <div className="grid-3">
          {biensFiltres.map(b => (
            <div key={b.id} className="bien-card">
              <div className="bien-header">
                <div className="bien-icon">{b.photo}</div>
                <div>
                  <div className="bien-adresse">{b.adresse}</div>
                  <div className="bien-type">{b.type}{b.surface ? ` · ${b.surface} m²` : ""}</div>
                </div>
              </div>
              <div className="bien-body">
                <div className="bien-row"><span className="bien-row-lbl">Loyer CC</span><span className="loyer-big">{(b.loyer + (b.charges||0)).toLocaleString("fr")} €</span></div>
                {isAdmin && b.proprietaire_nom && <div className="bien-row"><span className="bien-row-lbl">Propriétaire</span><span>{b.proprietaire_nom}</span></div>}
                <div className="bien-row"><span className="bien-row-lbl">Locataire</span><span>{b.locataire_nom || "—"}</span></div>
                {b.bail_debut && <div className="bien-row"><span className="bien-row-lbl">Bail</span><span>{b.bail_debut} → {b.bail_fin}</span></div>}
              </div>
              <div className="bien-footer">
                <BadgeStatut s={b.statut} />
                {isAdmin && (
                  <button
                    className="btn btn-danger"
                    style={{ padding: "5px 12px", fontSize: 11 }}
                    onClick={e => { e.stopPropagation(); handleDelete(b.id); }}
                  >
                    🗑 Supprimer
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <Modal title="Ajouter un bien" onClose={() => setShowModal(false)}>
          <form onSubmit={handleAdd}>
            <div className="form-group"><label className="form-label">Adresse complète</label><input className="form-input" placeholder="12 Rue des Lilas, 64100 Bayonne" value={form.adresse} onChange={e => setForm({...form, adresse: e.target.value})} required /></div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11, marginBottom: 13 }}>
              <div className="form-group"><label className="form-label">Type</label>
                <select className="form-input" value={form.type} onChange={e => setForm({...form, type: e.target.value})}>
                  <option>Appartement</option><option>Maison</option><option>Studio</option><option>Local commercial</option>
                </select>
              </div>
              <div className="form-group"><label className="form-label">Surface (m²)</label><input className="form-input" type="number" placeholder="55" value={form.surface} onChange={e => setForm({...form, surface: e.target.value})} /></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11, marginBottom: 13 }}>
              <div className="form-group"><label className="form-label">Loyer HC (€)</label><input className="form-input" type="number" placeholder="800" value={form.loyer} onChange={e => setForm({...form, loyer: e.target.value})} required /></div>
              <div className="form-group"><label className="form-label">Charges (€)</label><input className="form-input" type="number" placeholder="80" value={form.charges} onChange={e => setForm({...form, charges: e.target.value})} /></div>
            </div>
            {isAdmin && (
              <div className="form-group"><label className="form-label">Propriétaire</label>
                <select className="form-input" value={form.proprietaire_nom} onChange={e => setForm({...form, proprietaire_nom: e.target.value})}>
                  <option value="">— Sélectionner —</option>
                  {proprietaires.map(p => <option key={p.id} value={p.nom}>{p.nom}</option>)}
                </select>
              </div>
            )}
            <div className="form-group"><label className="form-label">Locataire</label>
              <select className="form-input" value={form.locataire_nom} onChange={e => setForm({...form, locataire_nom: e.target.value})}>
                <option value="">— Aucun (bien vacant) —</option>
                {locataires.map(p => <option key={p.id} value={p.nom}>{p.nom}</option>)}
              </select>
            </div>
            {form.locataire_nom && (
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11, marginBottom: 13 }}>
                <div className="form-group"><label className="form-label">Début du bail</label><input className="form-input" placeholder="JJ/MM/AAAA" value={form.bail_debut} onChange={e => setForm({...form, bail_debut: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Fin du bail</label><input className="form-input" placeholder="JJ/MM/AAAA" value={form.bail_fin} onChange={e => setForm({...form, bail_fin: e.target.value})} /></div>
              </div>
            )}
            <div className="modal-actions">
              <button className="btn btn-ghost" type="button" onClick={() => setShowModal(false)}>Annuler</button>
              <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? "Enregistrement..." : "Enregistrer"}</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE LOYERS
// ─────────────────────────────────────────────
function PageLoyers({ paiements, profiles, biens, currentProfile, isAdmin, onRefresh }) {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ bien_adresse: "", locataire_nom: "", mois: "", montant: "", statut: "En attente", date_paiement: "" });
  const [saving, setSaving] = useState(false);

  const locataires   = profiles.filter(p => p.role === "locataire");
  const mesBiens     = isAdmin ? biens : biens.filter(b => b.proprietaire_nom === currentProfile.nom);
  const mesPaiements = isAdmin ? paiements : paiements.filter(p => mesBiens.some(b => b.adresse === p.bien_adresse || b.locataire_nom === p.locataire_nom));

  async function handleAdd(e) {
    e.preventDefault(); setSaving(true);
    await supabase.from("paiements").insert({ ...form, montant: parseInt(form.montant) });
    setSaving(false); setShowModal(false);
    setForm({ bien_adresse: "", locataire_nom: "", mois: "", montant: "", statut: "En attente", date_paiement: "" });
    onRefresh();
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Enregistrer un paiement</button>
      </div>
      <div className="card">
        <ST>Loyers & paiements</ST>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Locataire</th><th>Mois</th><th>Montant</th><th>Date</th><th>Statut</th></tr></thead>
            <tbody>
              {mesPaiements.map(p => (
                <tr key={p.id}>
                  <td><strong>{p.locataire_nom}</strong></td>
                  <td>{p.mois}</td>
                  <td><strong>{p.montant.toLocaleString("fr")} €</strong></td>
                  <td style={{ fontSize: 12, color: "var(--gray-text)" }}>{p.date_paiement || "—"}</td>
                  <td><BadgeStatut s={p.statut} /></td>
                </tr>
              ))}
              {mesPaiements.length === 0 && <tr><td colSpan={5} style={{ textAlign: "center", color: "var(--gray-text)", padding: 20 }}>Aucun paiement enregistré</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <Modal title="Enregistrer un paiement" onClose={() => setShowModal(false)}>
          <form onSubmit={handleAdd}>
            <div className="form-group"><label className="form-label">Locataire</label>
              <select className="form-input" value={form.locataire_nom} onChange={e => setForm({...form, locataire_nom: e.target.value})} required>
                <option value="">— Sélectionner —</option>
                {locataires.map(p => <option key={p.id} value={p.nom}>{p.nom}</option>)}
              </select>
            </div>
            <div className="form-group"><label className="form-label">Bien</label>
              <select className="form-input" value={form.bien_adresse} onChange={e => setForm({...form, bien_adresse: e.target.value})}>
                <option value="">— Sélectionner —</option>
                {mesBiens.map(b => <option key={b.id} value={b.adresse}>{b.adresse}</option>)}
              </select>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11, marginBottom: 13 }}>
              <div className="form-group"><label className="form-label">Mois</label><input className="form-input" placeholder="Juin 2026" value={form.mois} onChange={e => setForm({...form, mois: e.target.value})} required /></div>
              <div className="form-group"><label className="form-label">Montant (€)</label><input className="form-input" type="number" placeholder="1150" value={form.montant} onChange={e => setForm({...form, montant: e.target.value})} required /></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11, marginBottom: 13 }}>
              <div className="form-group"><label className="form-label">Statut</label>
                <select className="form-input" value={form.statut} onChange={e => setForm({...form, statut: e.target.value})}>
                  <option>En attente</option><option>Payé</option><option>Retard</option>
                </select>
              </div>
              <div className="form-group"><label className="form-label">Date de paiement</label><input className="form-input" placeholder="JJ/MM/AAAA" value={form.date_paiement} onChange={e => setForm({...form, date_paiement: e.target.value})} /></div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-ghost" type="button" onClick={() => setShowModal(false)}>Annuler</button>
              <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? "Enregistrement..." : "Enregistrer"}</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE TRAVAUX
// ─────────────────────────────────────────────
function PageTravaux({ travaux, biens, currentProfile, isAdmin, isLocataire, onRefresh }) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ bien_adresse: "", description: "", priorite: "Moyenne" });

  const mesBiens    = isAdmin ? biens : isLocataire ? biens.filter(b => b.locataire_nom === currentProfile.nom) : biens.filter(b => b.proprietaire_nom === currentProfile.nom);
  const mesTravaux  = isAdmin ? travaux : travaux.filter(t => mesBiens.some(b => b.adresse === t.bien_adresse));

  async function handleAdd(e) {
    e.preventDefault();
    await supabase.from("travaux").insert({ ...form, statut: "Planifié", signale_par: currentProfile.nom });
    setShowForm(false); setForm({ bien_adresse: "", description: "", priorite: "Moyenne" }); onRefresh();
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ {isLocataire ? "Signaler un problème" : "Ajouter une intervention"}</button>
      </div>
      <div className="card">
        <ST>Interventions & travaux</ST>
        {mesTravaux.map(t => (
          <div key={t.id} className="travail-item">
            <div className="travail-ico">🔧</div>
            <div style={{ flex: 1 }}>
              <div className="travail-desc">{t.description}</div>
              <div className="travail-meta">{t.bien_adresse} · Signalé par {t.signale_par} · {new Date(t.created_at).toLocaleDateString("fr-FR")}</div>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
              <BadgeStatut s={t.statut} />
              <span className="badge badge-gray" style={{ fontSize: 10 }}>{t.priorite}</span>
            </div>
          </div>
        ))}
        {mesTravaux.length === 0 && <div className="empty"><div className="empty-icon">✅</div><div className="empty-text">Aucune intervention</div></div>}
      </div>

      {showForm && (
        <Modal title={isLocataire ? "Signaler un problème" : "Ajouter une intervention"} onClose={() => setShowForm(false)}>
          <form onSubmit={handleAdd}>
            <div className="form-group"><label className="form-label">Bien concerné</label>
              <select className="form-input" value={form.bien_adresse} onChange={e => setForm({...form, bien_adresse: e.target.value})} required>
                <option value="">— Sélectionner —</option>
                {mesBiens.map(b => <option key={b.id} value={b.adresse}>{b.adresse}</option>)}
              </select>
            </div>
            <div className="form-group"><label className="form-label">Description</label><textarea className="form-input" rows={3} placeholder="Décrivez le problème..." value={form.description} onChange={e => setForm({...form, description: e.target.value})} required /></div>
            <div className="form-group"><label className="form-label">Urgence</label>
              <select className="form-input" value={form.priorite} onChange={e => setForm({...form, priorite: e.target.value})}>
                <option>Haute</option><option>Moyenne</option><option>Basse</option>
              </select>
            </div>
            <div className="modal-actions">
              <button className="btn btn-ghost" type="button" onClick={() => setShowForm(false)}>Annuler</button>
              <button className="btn btn-primary" type="submit">Envoyer</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE MESSAGES
// ─────────────────────────────────────────────
function PageMessages({ profile, messages, onRefresh }) {
  const [selected, setSelected] = useState(null);
  const [newMsg,   setNewMsg]   = useState("");
  const [showNew,  setShowNew]  = useState(false);
  const [destNom,  setDestNom]  = useState("");
  const [sujetNew, setSujetNew] = useState("");
  const [msgNew,   setMsgNew]   = useState("");

  const mesMsgs = messages.filter(m => m.de_nom === profile.nom || m.a_nom === profile.nom);
  const threads = [...new Set(mesMsgs.map(m => m.sujet.replace(/^Re: /, "")))];

  async function sendReply() {
    if (!newMsg.trim()) return;
    const thread = mesMsgs.filter(m => m.sujet === selected || m.sujet === `Re: ${selected}`);
    const last   = thread[thread.length - 1];
    const dest   = last.de_nom === profile.nom ? last.a_nom : last.de_nom;
    await supabase.from("messages").insert({ de_nom: profile.nom, a_nom: dest, sujet: `Re: ${selected}`, message: newMsg, lu: false });
    setNewMsg(""); onRefresh();
  }

  async function sendNew(e) {
    e.preventDefault();
    await supabase.from("messages").insert({ de_nom: profile.nom, a_nom: destNom, sujet: sujetNew, message: msgNew, lu: false });
    setDestNom(""); setSujetNew(""); setMsgNew(""); setShowNew(false); onRefresh();
  }

  return (
    <div className="grid-2" style={{ alignItems: "start" }}>
      <div className="card">
        <ST>Conversations</ST>
        {threads.map((thread, i) => {
          const msgs   = mesMsgs.filter(m => m.sujet === thread || m.sujet === `Re: ${thread}`);
          const last   = msgs[msgs.length - 1];
          const unread = msgs.some(m => m.a_nom === profile.nom && !m.lu);
          return (
            <div key={i} className={`msg-item${unread ? " unread" : ""}`} onClick={() => setSelected(thread)}>
              {unread && <div className="msg-dot" />}
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div className="msg-from">{thread}</div>
                  <div className="msg-date">{new Date(last.created_at).toLocaleDateString("fr-FR")}</div>
                </div>
                <div className="msg-prev">{last.message}</div>
              </div>
            </div>
          );
        })}
        {threads.length === 0 && <div style={{ padding: 24, textAlign: "center", color: "var(--gray-text)", fontSize: 13 }}>Aucune conversation</div>}
        <div style={{ marginTop: 12 }}>
          <button className="btn btn-primary" style={{ width: "100%" }} onClick={() => setShowNew(true)}>+ Nouveau message</button>
        </div>
      </div>

      <div>
        {selected ? (
          <div className="card">
            <ST>{selected}</ST>
            {mesMsgs.filter(m => m.sujet === selected || m.sujet === `Re: ${selected}`).map(m => (
              <div key={m.id} style={{ marginBottom: 9, padding: "10px 13px", borderRadius: 5, background: m.de_nom === profile.nom ? "var(--green-pale)" : "var(--gray-bg)", borderLeft: `3px solid ${m.de_nom === profile.nom ? "var(--green)" : "var(--gray-line)"}` }}>
                <div style={{ fontSize: 11, color: "var(--gray-text)", marginBottom: 3, fontWeight: 700, textTransform: "uppercase" }}>{m.de_nom} · {new Date(m.created_at).toLocaleDateString("fr-FR")}</div>
                <div style={{ fontSize: 13 }}>{m.message}</div>
              </div>
            ))}
            <div className="compose-box">
              <textarea className="compose-input" placeholder="Votre réponse..." value={newMsg} onChange={e => setNewMsg(e.target.value)} />
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                <button className="btn btn-primary" onClick={sendReply}>Envoyer</button>
              </div>
            </div>
          </div>
        ) : (
          <div className="card empty"><div className="empty-icon">💬</div><div className="empty-text">Sélectionnez une conversation</div></div>
        )}
      </div>

      {showNew && (
        <Modal title="Nouveau message" onClose={() => setShowNew(false)}>
          <form onSubmit={sendNew}>
            <div className="form-group"><label className="form-label">Destinataire (nom exact)</label><input className="form-input" placeholder="Prénom Nom" value={destNom} onChange={e => setDestNom(e.target.value)} required /></div>
            <div className="form-group"><label className="form-label">Objet</label><input className="form-input" placeholder="Objet du message" value={sujetNew} onChange={e => setSujetNew(e.target.value)} required /></div>
            <div className="form-group"><label className="form-label">Message</label><textarea className="form-input" rows={4} placeholder="Votre message..." value={msgNew} onChange={e => setMsgNew(e.target.value)} required /></div>
            <div className="modal-actions">
              <button className="btn btn-ghost" type="button" onClick={() => setShowNew(false)}>Annuler</button>
              <button className="btn btn-primary" type="submit">Envoyer</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE DOCUMENTS
// ─────────────────────────────────────────────
function PageDocuments({ documents, profile, isAdmin, biens }) {
  // Pour un locataire ou propriétaire, filtrer ses documents
  const mesDocs = isAdmin
    ? documents
    : documents.filter(d => d.associe_nom === profile.nom);

  function getIcon(nom) {
    const ext = (nom || "").split(".").pop().toLowerCase();
    if (ext === "pdf") return "📄";
    if (["jpg","jpeg","png","gif","webp"].includes(ext)) return "🖼️";
    if (["doc","docx"].includes(ext)) return "📝";
    if (["xls","xlsx"].includes(ext)) return "📊";
    return "📎";
  }

  return (
    <div className="card">
      <ST>Documents ({mesDocs.length})</ST>
      {mesDocs.length === 0 ? (
        <div className="empty"><div className="empty-icon">📁</div><div className="empty-text">Aucun document disponible</div></div>
      ) : (
        mesDocs.map(d => (
          <div key={d.id} className="doc-item">
            <div className="doc-icon">{getIcon(d.nom)}</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div className="doc-name" style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{d.nom}</div>
              <div className="doc-meta">
                {d.type}
                {d.associe_nom && isAdmin ? ` · ${d.associe_nom}` : ""}
                {" · "}{new Date(d.created_at).toLocaleDateString("fr-FR")}
              </div>
            </div>
            {d.url && (
              <a href={d.url} target="_blank" rel="noreferrer" className="btn btn-ghost" style={{ padding:"5px 12px", fontSize:11, textDecoration:"none" }}>
                ⬇ Ouvrir
              </a>
            )}
          </div>
        ))
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE VERSEMENTS PROPRIÉTAIRES
// ─────────────────────────────────────────────
function PageVersements({ versements, biens, profiles, currentProfile, isAdmin, onRefresh }) {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    bien_adresse: "", proprietaire_nom: "", locataire_nom: "",
    mois: "", loyer_brut: "", taux_honoraires: "8",
    statut: "En attente", date_versement: ""
  });
  const [saving, setSaving] = useState(false);

  const proprietaires = profiles.filter(p => p.role === "proprietaire");
  const mesVersements = isAdmin
    ? versements
    : versements.filter(v => v.proprietaire_nom === currentProfile.nom);
  const mesBiens = isAdmin ? biens : biens.filter(b => b.proprietaire_nom === currentProfile.nom);

  const totalHonoraires = versements.reduce((s, v) => s + (v.honoraires || 0), 0);
  const totalVerse      = versements.filter(v => v.statut === "Versé").reduce((s, v) => s + (v.loyer_net || 0), 0);
  const totalAttente    = versements.filter(v => v.statut === "En attente").reduce((s, v) => s + (v.loyer_net || 0), 0);

  function calcHonoraires(brut, taux) {
    return Math.round((brut * taux) / 100);
  }

  async function handleAdd(e) {
    e.preventDefault(); setSaving(true);
    const brut  = parseInt(form.loyer_brut) || 0;
    const taux  = parseFloat(form.taux_honoraires) || 8;
    const hon   = calcHonoraires(brut, taux);
    const net   = brut - hon;
    await supabase.from("versements").insert({
      ...form,
      loyer_brut: brut,
      taux_honoraires: taux,
      honoraires: hon,
      loyer_net: net,
    });
    setSaving(false); setShowModal(false);
    setForm({ bien_adresse:"", proprietaire_nom:"", locataire_nom:"", mois:"", loyer_brut:"", taux_honoraires:"8", statut:"En attente", date_versement:"" });
    onRefresh();
  }

  async function handleStatut(id, statut) {
    const date = statut === "Versé" ? new Date().toLocaleDateString("fr-FR") : "";
    await supabase.from("versements").update({ statut, date_versement: date }).eq("id", id);
    onRefresh();
  }

  async function handleDelete(id) {
    if (!window.confirm("Supprimer ce versement ?")) return;
    await supabase.from("versements").delete().eq("id", id);
    onRefresh();
  }

  const brut = parseInt(form.loyer_brut) || 0;
  const taux = parseFloat(form.taux_honoraires) || 8;
  const hon  = calcHonoraires(brut, taux);
  const net  = brut - hon;

  return (
    <div>
      {isAdmin && (
        <div className="grid-3 g20">
          {[
            { ico:"💰", l:"Honoraires encaissés",    v:`${totalHonoraires.toLocaleString("fr")} €`, accent:true },
            { ico:"✅", l:"Loyers versés",             v:`${totalVerse.toLocaleString("fr")} €` },
            { ico:"⏳", l:"Versements en attente",    v:`${totalAttente.toLocaleString("fr")} €` },
          ].map((k, i) => (
            <div key={i} className="card">
              <div className="kpi-ico">{k.ico}</div>
              <div className={`kpi-val${k.accent?" accent":""}`}>{k.v}</div>
              <div className="kpi-lbl">{k.l}</div>
            </div>
          ))}
        </div>
      )}

      {isAdmin && (
        <div style={{ display:"flex", justifyContent:"flex-end", margin:"20px 0 16px" }}>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Enregistrer un versement</button>
        </div>
      )}

      <div className="card">
        <ST>{isAdmin ? "Tous les versements" : "Mes versements"}</ST>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Propriétaire</th>
                <th>Bien</th>
                <th>Mois</th>
                <th>Loyer brut</th>
                <th>Honoraires ({form.taux_honoraires}%)</th>
                <th>Net versé</th>
                <th>Statut</th>
                {isAdmin && <th>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {mesVersements.map(v => (
                <tr key={v.id}>
                  <td><strong>{v.proprietaire_nom}</strong></td>
                  <td style={{ fontSize:12, color:"var(--gray-text)" }}>{v.bien_adresse ? v.bien_adresse.split(",")[0] : "—"}</td>
                  <td>{v.mois}</td>
                  <td>{(v.loyer_brut||0).toLocaleString("fr")} €</td>
                  <td style={{ color:"var(--green)", fontWeight:600 }}>{(v.honoraires||0).toLocaleString("fr")} €</td>
                  <td><strong>{(v.loyer_net||0).toLocaleString("fr")} €</strong></td>
                  <td>
                    {v.statut === "Versé"
                      ? <span className="badge badge-green">✓ Versé {v.date_versement ? "· "+v.date_versement : ""}</span>
                      : <span className="badge badge-orange">⏳ En attente</span>
                    }
                  </td>
                  {isAdmin && (
                    <td>
                      <div style={{ display:"flex", gap:6 }}>
                        {v.statut === "En attente" && (
                          <button className="btn btn-primary" style={{ padding:"4px 10px", fontSize:11 }} onClick={() => handleStatut(v.id, "Versé")}>
                            ✓ Marquer versé
                          </button>
                        )}
                        {v.statut === "Versé" && (
                          <button className="btn btn-ghost" style={{ padding:"4px 10px", fontSize:11 }} onClick={() => handleStatut(v.id, "En attente")}>
                            ↩ Annuler
                          </button>
                        )}
                        <button className="btn btn-danger" style={{ padding:"4px 10px", fontSize:11 }} onClick={() => handleDelete(v.id)}>✕</button>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
              {mesVersements.length === 0 && (
                <tr><td colSpan={isAdmin ? 8 : 7} style={{ textAlign:"center", color:"var(--gray-text)", padding:24 }}>
                  Aucun versement enregistré
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showModal && (
        <Modal title="Enregistrer un versement" onClose={() => setShowModal(false)}>
          <form onSubmit={handleAdd}>
            <div className="form-group">
              <label className="form-label">Propriétaire</label>
              <select className="form-input" value={form.proprietaire_nom} onChange={e => setForm({...form, proprietaire_nom:e.target.value})} required>
                <option value="">— Sélectionner —</option>
                {proprietaires.map(p => <option key={p.id} value={p.nom}>{p.nom}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Bien</label>
              <select className="form-input" value={form.bien_adresse} onChange={e => {
                const bien = biens.find(b => b.adresse === e.target.value);
                setForm({...form, bien_adresse:e.target.value, locataire_nom: bien?.locataire_nom || ""});
              }}>
                <option value="">— Sélectionner —</option>
                {mesBiens.map(b => <option key={b.id} value={b.adresse}>{b.adresse.split(",")[0]}</option>)}
              </select>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:11, marginBottom:13 }}>
              <div className="form-group">
                <label className="form-label">Mois</label>
                <input className="form-input" placeholder="Juin 2026" value={form.mois} onChange={e => setForm({...form, mois:e.target.value})} required />
              </div>
              <div className="form-group">
                <label className="form-label">Loyer brut (€)</label>
                <input className="form-input" type="number" placeholder="1000" value={form.loyer_brut} onChange={e => setForm({...form, loyer_brut:e.target.value})} required />
              </div>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:11, marginBottom:13 }}>
              <div className="form-group">
                <label className="form-label">Taux honoraires (%)</label>
                <input className="form-input" type="number" step="0.5" value={form.taux_honoraires} onChange={e => setForm({...form, taux_honoraires:e.target.value})} />
              </div>
              <div className="form-group">
                <label className="form-label">Statut</label>
                <select className="form-input" value={form.statut} onChange={e => setForm({...form, statut:e.target.value})}>
                  <option>En attente</option><option>Versé</option>
                </select>
              </div>
            </div>
            {brut > 0 && (
              <div style={{ background:"var(--green-bg)", border:"1px solid #B8DEB8", borderRadius:6, padding:"12px 14px", marginBottom:14 }}>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:13, marginBottom:4 }}>
                  <span style={{ color:"var(--gray-text)" }}>Honoraires ({taux}%)</span>
                  <strong style={{ color:"var(--green)" }}>{hon.toLocaleString("fr")} €</strong>
                </div>
                <div style={{ display:"flex", justifyContent:"space-between", fontSize:14 }}>
                  <span style={{ fontWeight:600 }}>Net à verser au propriétaire</span>
                  <strong style={{ fontSize:16, color:"var(--black)" }}>{net.toLocaleString("fr")} €</strong>
                </div>
              </div>
            )}
            <div className="modal-actions">
              <button className="btn btn-ghost" type="button" onClick={() => setShowModal(false)}>Annuler</button>
              <button className="btn btn-primary" type="submit" disabled={saving}>{saving ? "Enregistrement..." : "Enregistrer"}</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

// ─────────────────────────────────────────────
// PAGE FISCALITÉ
// ─────────────────────────────────────────────
function PageFiscalite({ biens, paiements, currentProfile, isAdmin }) {
  const mesBiens     = isAdmin ? biens : biens.filter(b => b.proprietaire_nom === currentProfile.nom);
  const mesPaiements = isAdmin ? paiements : paiements.filter(p => mesBiens.some(b => b.locataire_nom === p.locataire_nom));
  const totalEncaisse = mesPaiements.filter(p => p.statut === "Payé").reduce((s, p) => s + p.montant, 0);

  return (
    <div>
      <div className="grid-3 g20">
        {[
          { label: "Revenus encaissés",   value: `${totalEncaisse.toLocaleString("fr")} €`, accent: true },
          { label: "Biens en location",   value: mesBiens.filter(b => b.statut === "Occupé").length },
          { label: "Biens vacants",       value: mesBiens.filter(b => b.statut === "Vacant").length },
        ].map((k, i) => (
          <div key={i} className="card">
            <div className="kpi-lbl">{k.label}</div>
            <div className={`kpi-val${k.accent ? " accent" : ""}`} style={{ marginTop: 8 }}>{k.value}</div>
          </div>
        ))}
      </div>
      <div className="card">
        <ST>Détail par bien</ST>
        <table>
          <thead><tr><th>Bien</th><th>Loyer HC</th><th>Revenus annuels</th><th>Charges</th></tr></thead>
          <tbody>
            {mesBiens.filter(b => b.statut === "Occupé").map(b => (
              <tr key={b.id}>
                <td style={{ fontSize: 12 }}>{b.adresse}</td>
                <td>{b.loyer.toLocaleString("fr")} €</td>
                <td><strong style={{ color: "var(--green)" }}>{(b.loyer * 12).toLocaleString("fr")} €</strong></td>
                <td style={{ color: "var(--gray-text)" }}>{((b.charges||0) * 12).toLocaleString("fr")} €</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// APP PRINCIPALE
// ─────────────────────────────────────────────
export default function App() {
  const [profile,   setProfile]   = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [page,      setPage]      = useState("dashboard");
  const [biens,     setBiens]     = useState([]);
  const [paiements, setPaiements] = useState([]);
  const [messages,  setMessages]  = useState([]);
  const [travaux,   setTravaux]   = useState([]);
  const [documents, setDocuments] = useState([]);
  const [versements, setVersements] = useState([]);
  const [profiles,  setProfiles]  = useState([]);

  useEffect(() => {
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session) {
        const { data } = await supabase.from("profiles").select("*").eq("id", session.user.id).single();
        if (data) setProfile(data);
        else if (session.user.email === ADMIN_EMAIL) {
          const p = { id: session.user.id, email: ADMIN_EMAIL, nom: "Arnaud Lamothe", role: "admin", avatar: "AL" };
          await supabase.from("profiles").upsert(p);
          setProfile(p);
        }
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => { if (profile) loadData(); }, [profile]);

  async function loadData() {
    const [b, p, m, t, d, pr, v] = await Promise.all([
      supabase.from("biens").select("*").order("id"),
      supabase.from("paiements").select("*").order("created_at", { ascending: false }),
      supabase.from("messages").select("*").order("created_at"),
      supabase.from("travaux").select("*").order("created_at", { ascending: false }),
      supabase.from("documents").select("*").order("created_at", { ascending: false }),
      supabase.from("profiles").select("*").order("nom"),
      supabase.from("versements").select("*").order("created_at", { ascending: false }),
    ]);
    if (b.data)  setBiens(b.data);
    if (p.data)  setPaiements(p.data);
    if (m.data)  setMessages(m.data);
    if (t.data)  setTravaux(t.data);
    if (d.data)  setDocuments(d.data);
    if (pr.data) setProfiles(pr.data);
    if (v.data)  setVersements(v.data);
  }

  async function handleLogout() {
    await supabase.auth.signOut(); setProfile(null); setPage("dashboard");
  }

  if (loading)  return <><style>{css}</style><div className="loading">Chargement...</div></>;
  if (!profile) return <><style>{css}</style><AuthPage onAuth={p => { setProfile(p); }} /></>;

  const isAdmin    = profile.role === "admin" || profile.email === ADMIN_EMAIL;
  const isProp     = profile.role === "proprietaire";
  const isLocataire = profile.role === "locataire";
  const unread     = messages.filter(m => m.a_nom === profile.nom && !m.lu).length;
  const monBien    = biens.find(b => b.locataire_nom === profile.nom);
  const mesPaie    = paiements.filter(p => p.locataire_nom === profile.nom);

  const titres = {
    dashboard: isAdmin ? "Tableau de bord Admin" : isProp ? "Mes biens" : "Mon espace",
    utilisateurs: "Utilisateurs & invitations", biens: isAdmin ? "Tous les biens" : "Mes biens",
    locataires: "Mes locataires", loyers: "Loyers & quittances",
    travaux: isLocataire ? "Signaler un problème" : "Travaux & interventions",
    documents: "Documents", messages: "Messages", fiscalite: "Revenus fonciers",
    "mon-bail": "Mon bail", "mes-paiements": "Mes paiements",
    versements: isAdmin ? "Paiements propriétaires" : "Mes versements",
  };

  function renderDashboard() {
    if (isAdmin) {
      const totalEncaisse = paiements.filter(p => p.statut === "Payé").reduce((s, p) => s + p.montant, 0);
      return (
        <div>
          <div className="grid-4 g20">
            {[
              { ico:"🏠", l:"Biens gérés",      v:biens.length,                                  s:`${biens.filter(b=>b.statut==="Occupé").length} occupés` },
              { ico:"👥", l:"Utilisateurs",      v:profiles.length,                               s:`${profiles.filter(p=>p.role==="proprietaire").length} prop. · ${profiles.filter(p=>p.role==="locataire").length} loc.` },
              { ico:"💶", l:"Revenus encaissés", v:`${totalEncaisse.toLocaleString("fr")} €`,     s:"Total paiements", accent:true },
              { ico:"⏳", l:"En attente",        v:paiements.filter(p=>p.statut==="En attente").length, s:"Paiements" },
            ].map((k, i) => (
              <div key={i} className="card">
                <div className="kpi-ico">{k.ico}</div>
                <div className={`kpi-val${k.accent ? " accent" : ""}`}>{k.v}</div>
                <div className="kpi-lbl">{k.l}</div>
                <div className="kpi-sub">{k.s}</div>
              </div>
            ))}
          </div>
          <div className="grid-2">
            <div className="card">
              <ST>Derniers paiements</ST>
              <table><thead><tr><th>Locataire</th><th>Mois</th><th>Montant</th><th>Statut</th></tr></thead>
                <tbody>{paiements.slice(0, 5).map(p => (<tr key={p.id}><td>{p.locataire_nom}</td><td>{p.mois}</td><td><strong>{p.montant.toLocaleString("fr")} €</strong></td><td><BadgeStatut s={p.statut} /></td></tr>))}</tbody>
              </table>
            </div>
            <div className="card">
              <ST>Interventions récentes</ST>
              {travaux.slice(0, 4).map(t => (
                <div key={t.id} className="travail-item">
                  <div className="travail-ico">🔧</div>
                  <div style={{ flex: 1 }}><div className="travail-desc">{t.description}</div><div className="travail-meta">{t.signale_par}</div></div>
                  <BadgeStatut s={t.statut} />
                </div>
              ))}
              {travaux.length === 0 && <div className="empty"><div className="empty-text">Aucune intervention</div></div>}
            </div>
          </div>
        </div>
      );
    }
    if (isProp) {
      const mesBiens = biens.filter(b => b.proprietaire_nom === profile.nom);
      const total    = paiements.filter(p => mesBiens.some(b => b.locataire_nom === p.locataire_nom) && p.statut === "Payé").reduce((s, p) => s + p.montant, 0);
      return (
        <div>
          <div className="grid-3 g20">
            {[
              { ico:"🏠", l:"Mes biens",         v:mesBiens.length, s:`${mesBiens.filter(b=>b.statut==="Occupé").length} occupés` },
              { ico:"💶", l:"Revenus encaissés",  v:`${total.toLocaleString("fr")} €`, s:"Total", accent:true },
              { ico:"👥", l:"Locataires actifs",  v:mesBiens.filter(b=>b.locataire_nom).length, s:"En cours de bail" },
            ].map((k, i) => (
              <div key={i} className="card">
                <div className="kpi-ico">{k.ico}</div>
                <div className={`kpi-val${k.accent ? " accent" : ""}`}>{k.v}</div>
                <div className="kpi-lbl">{k.l}</div>
                <div className="kpi-sub">{k.s}</div>
              </div>
            ))}
          </div>
          <div className="grid-3">
            {mesBiens.map(b => (
              <div key={b.id} className="bien-card">
                <div className="bien-header"><div className="bien-icon">{b.photo}</div><div><div className="bien-adresse">{b.adresse}</div><div className="bien-type">{b.type}</div></div></div>
                <div className="bien-body">
                  <div className="bien-row"><span className="bien-row-lbl">Loyer CC</span><span className="loyer-big">{(b.loyer+(b.charges||0)).toLocaleString("fr")} €</span></div>
                  <div className="bien-row"><span className="bien-row-lbl">Locataire</span><span>{b.locataire_nom || "—"}</span></div>
                </div>
                <div className="bien-footer"><BadgeStatut s={b.statut} /></div>
              </div>
            ))}
            {mesBiens.length === 0 && <div className="card empty"><div className="empty-icon">🏠</div><div className="empty-text">Aucun bien associé</div></div>}
          </div>
        </div>
      );
    }
    // Locataire
    return (
      <div>
        <div className="loc-hero">
          <div><div className="loc-hero-title">Bonjour, {profile.nom.split(" ")[0]} 👋</div><div className="loc-hero-sub">{monBien ? `${monBien.adresse} · ${monBien.type}` : "Aucun bien associé à votre compte"}</div></div>
          {monBien && <div style={{ textAlign: "right" }}><div style={{ fontFamily: "'Lora',serif", fontSize: 24 }}>{(monBien.loyer+(monBien.charges||0)).toLocaleString("fr")} €</div><div style={{ fontSize: 11, opacity: .75 }}>/ mois CC</div></div>}
        </div>
        <div className="grid-3">
          {[
            { ico:"💶", l:"Paiements à jour", v:mesPaie.filter(p=>p.statut==="Payé").length, s:`Sur ${mesPaie.length} mois` },
            { ico:"📄", l:"Fin de bail",      v:monBien?.bail_fin || "—", s:"Date d'échéance" },
            { ico:"🔧", l:"Interventions",    v:travaux.filter(t=>t.bien_adresse===monBien?.adresse&&t.statut!=="Terminé").length, s:"En cours" },
          ].map((k, i) => (
            <div key={i} className="card"><div className="kpi-ico">{k.ico}</div><div className="kpi-val accent">{k.v}</div><div className="kpi-lbl">{k.l}</div><div className="kpi-sub">{k.s}</div></div>
          ))}
        </div>
      </div>
    );
  }

  function renderPage() {
    switch(page) {
      case "dashboard":    return renderDashboard();
      case "utilisateurs": return <PageUtilisateurs profiles={profiles} biens={biens} documents={documents} onRefresh={loadData} />;
      case "biens":        return <PageBiens biens={biens} profiles={profiles} isAdmin={isAdmin} currentProfile={profile} onRefresh={loadData} />;
      case "locataires":   return (
        <div className="card"><ST>Mes locataires</ST>
          <table><thead><tr><th>Nom</th><th>Bien</th><th>Bail fin</th><th>Paiement</th></tr></thead>
            <tbody>{biens.filter(b=>b.proprietaire_nom===profile.nom&&b.locataire_nom).map(b=>{
              const p = paiements.filter(p=>p.locataire_nom===b.locataire_nom).sort((a,c)=>c.id-a.id)[0];
              return <tr key={b.id}><td><strong>{b.locataire_nom}</strong></td><td style={{fontSize:12}}>{b.adresse}</td><td>{b.bail_fin||"—"}</td><td>{p?<BadgeStatut s={p.statut}/>:"—"}</td></tr>;
            })}</tbody>
          </table>
        </div>
      );
      case "loyers": case "mes-paiements":
        return <PageLoyers paiements={isLocataire ? mesPaie : paiements} profiles={profiles} biens={biens} currentProfile={profile} isAdmin={isAdmin} onRefresh={loadData} />;
      case "travaux":   return <PageTravaux travaux={travaux} biens={biens} currentProfile={profile} isAdmin={isAdmin} isLocataire={isLocataire} onRefresh={loadData} />;
      case "documents": return <PageDocuments documents={documents} profile={profile} isAdmin={isAdmin} biens={biens} />;
      case "messages":  return <PageMessages profile={profile} messages={messages} onRefresh={loadData} />;
      case "versements": return <PageVersements versements={versements} biens={biens} profiles={profiles} currentProfile={profile} isAdmin={isAdmin} onRefresh={loadData} />;
      case "fiscalite": return <PageFiscalite biens={biens} paiements={paiements} currentProfile={profile} isAdmin={isAdmin} />;
      case "mon-bail":
        return monBien ? (
          <div>
            <div className="loc-hero">
              <div><div className="loc-hero-title">{monBien.adresse}</div><div className="loc-hero-sub">{monBien.type}{monBien.surface ? ` · ${monBien.surface} m²` : ""}</div></div>
              <div style={{ textAlign: "right" }}><div style={{ fontFamily:"'Lora',serif", fontSize:24 }}>{(monBien.loyer+(monBien.charges||0)).toLocaleString("fr")} €</div><div style={{ fontSize:11, opacity:.75 }}>/ mois CC</div></div>
            </div>
            <div className="grid-2">
              <div className="card"><ST>Détails du bail</ST>
                {[["Loyer HC",`${monBien.loyer.toLocaleString("fr")} €`],["Charges",`${monBien.charges||0} €`],["Début du bail",monBien.bail_debut||"—"],["Fin du bail",monBien.bail_fin||"—"],["Dépôt de garantie",`${(monBien.loyer*2).toLocaleString("fr")} €`]].map(([l,v])=>(
                  <div key={l} className="bien-row"><span style={{fontSize:12,color:"var(--gray-text)"}}>{l}</span><span style={{fontSize:13,fontWeight:600}}>{v}</span></div>
                ))}
              </div>
              <div className="card"><ST>Votre gestionnaire</ST>
                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16,padding:12,background:"var(--green-bg)",borderRadius:6}}>
                  <div style={{width:42,height:42,borderRadius:"50%",background:"var(--green)",display:"flex",alignItems:"center",justifyContent:"center",color:"white",fontWeight:700,fontSize:14}}>AL</div>
                  <div><div style={{fontWeight:700,fontSize:14}}>Arnaud Lamothe</div><div style={{fontSize:12,color:"var(--green)"}}>Gérant · Oreka Immobilier</div></div>
                </div>
                {[["📞","06 77 03 31 35"],["✉️","arnaudlamothe@oreka-immobilier.fr"],["📍","3 impasse des Sittelles, 64340 Boucau"]].map(([i,v])=>(
                  <div key={i} className="bien-row"><span style={{fontSize:12,color:"var(--gray-text)"}}>{i}</span><span style={{fontSize:12,fontWeight:500}}>{v}</span></div>
                ))}
              </div>
            </div>
          </div>
        ) : <div className="card empty"><div className="empty-icon">📄</div><div className="empty-text">Aucun bail associé à votre compte</div></div>;
      default: return renderDashboard();
    }
  }

  return (
    <>
      <style>{css}</style>
      <div className="app">
        <Sidebar profile={profile} activePage={page} onNav={setPage} onLogout={handleLogout} unread={unread} />
        <div className="main">
          <div className="topbar">
            <div>
              <div className="page-title">{titres[page] || page}</div>
              <div className="page-bar" />
              <div className="page-subtitle">Oreka Immobilier · {new Date().toLocaleDateString("fr-FR", { weekday:"long", day:"numeric", month:"long", year:"numeric" })}</div>
            </div>
          </div>
          <div className="content">{renderPage()}</div>
          <div className="footer-bar">
            <span>© 2026 Oreka Immobilier — Arnaud Lamothe</span>
            <span>📞 06 77 03 31 35 · arnaudlamothe@oreka-immobilier.fr</span>
            <a href="https://www.oreka-immobilier.fr" target="_blank" rel="noreferrer">www.oreka-immobilier.fr</a>
          </div>
        </div>
      </div>
    </>
  );
}